export const GENERAL_ACTION_TYPES = {
  filterClicked: 'FILTER_CLICKED',
  navigation: 'NAVIGATION',
  share: 'SHARE',
  highlight: 'HIGHLIGHT',
  dashboardSession: 'DASHBOARD_SESSION',
  menuClicked: 'MENU_BUTTON_CLICKED',
  toolbarClicked: 'TOOLBAR_BUTTON_CLICKED',
};

export const ACTION_TYPES = {
  filterClickedOnChart: 'FILTER_CLICKED_CHART',
  filterClickedOnSidenav: 'FILTER_CLICKED_SIDENAV',
  dashboardNavigation: 'DASHBOARD_NAVIGATION',
  landingNavigation: 'LANDING_NAVIGATION',
  share: 'SHARE',
  highlight: 'HIGHLIGHT',
  filtersButtonClicked: 'FILTERS_BUTTON_CLICKED',
  areasButtonClicked: 'AREAS_BUTTON_CLICKED',
  menuButtonClicked: 'MENU_BUTTON_CLICKED',
  homeButtonClicked: 'HOME_BUTTON_CLICKED',
  goBackButtonClicked: 'GO_BACK_BUTTON_CLICKED',
  showKpisButtonClicked: 'SHOW_KPIS_BUTTON_CLICKED',
  dashboardsButtonClicked: 'DASHBOARDS_BUTTON_CLICKED',
  refreshButtonClicked: 'REFRESH_BUTTON_CLICKED',
  logoutButtonClicked: 'LOGOUT_BUTTON_CLICKED',
  adminButtonClicked: 'ADMIN_BUTTON_CLICKED',
  switchThemeButtonClicked: 'SWITCH_THEME_BUTTON_CLICKED',
  activateMicrophoneButtonClicked: 'ACTIVATE_MICROPHONE_BUTTON_CLICKED',
  deactivateMicrophoneButtonClicked: 'DEACTIVATE_MICROPHONE_BUTTON_CLICKED',
  highlightButtonClicked: 'HIGHLIGHT_BUTTON_CLICKED',
  togglePanel: 'TOGGLE_PANEL',
  settingsButtonClicked: 'SETTINGS_BUTTON_CLICKED',
};

export const DASHBOARD_TYPES = {
  layoutDashboard: 'LAYOUT_DASHBOARD',
  mainKpiDashboard: 'MAIN_KPI_DASHBOARD',
  detailKpiDashboard: 'DETAIL_KPI_DASHBOARD',
};

export const APPLICATION = 'OD';

export const TRACKING_INCLUDED_URLS = {
  dashboard: 'dashboard',
  landing: 'landing',
};
